/** MEW toy image filenames in /public/images/mew/toys/ */
const MEW_TOY_IMAGES: Record<number, string> = {
  0: '0-taxi.png',
  1: '1-moto.png',
  2: '2-aircombat.png',
  3: '3-hot-air.png',
  4: '4-golden.png',
  5: '5-ufo.png',
};
const MEW_FALLBACK_IMAGE = '/images/mew/mew-landing.png';

/**
 * Returns the image URL for a MEW NFT by token type.
 * Uses images from /public/images/mew/toys/ (0-taxi through 5-ufo).
 */
export function getMewToyImageUrl(tokenType: number | undefined): string {
  if (tokenType == null || tokenType < 0 || !(tokenType in MEW_TOY_IMAGES)) {
    return MEW_FALLBACK_IMAGE;
  }
  return `/images/mew/toys/${MEW_TOY_IMAGES[tokenType]}`;
}
